<template>
  <v-container class="pa-0 ma-0">

    <v-row class="pa-0 ma-0">
      <v-col class="pa-0 ma-0" v-if="latitude && longitude">
        <GmapMap
          :center="{lat: this.latitude, lng: this.longitude}"
          :zoom="15"
          :style="`width: ${width}; height: ${height}`"
          :options="{
            zoomControl: false,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: false
          }"
        >
          <GmapMarker
            :position="{lat: this.latitude, lng: this.longitude }"
            :clickable="false" :draggable="false"
          />
        </GmapMap>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_API,
    region: 'pt',
    language: 'BR',
    libraries: 'places,visualization',
  },
});

export default {
  props: {
    latitude: {
      type: Number,
      required: true,
    },
    longitude: {
      type: Number,
      required: true,
    },
    width: {
      type: String,
      default: '270px',
    },
    height: {
      type: String,
      default: '230px',
    },
  },
};
</script>
